import { useBlockProps } from "@wordpress/block-editor";

export default function save({ attributes }) {
	const { lat, lng, zoom, height } = attributes;

	return (
		<>
			<div {...useBlockProps.save()}>
				<div id="map" style={{ height: `${height}px` }} />
			</div>

			<script>
				{`
						const map = L.map('map').setView([${lat}, ${lng}], ${zoom});
						L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);
						L.marker([${lat}, ${lng}]).addTo(map)
				`}
			</script>
		</>
	);
}
